var map = {
	"./CardTypes.png": 1202,
	"./CardTypesTwo.png": 1203,
	"./Cards/amex.png": 416,
	"./Cards/defaultLogo.png": 417,
	"./Cards/mastercard.png": 418,
	"./Cards/rupay.png": 419,
	"./Cards/visa.png": 420,
	"./Edit.png": 1204,
	"./NetBanking.png": 1205,
	"./SuccessRate.svg": 421,
	"./View.png": 67,
	"./access.png": 1206,
	"./action.png": 1207,
	"./add.png": 1208,
	"./alert-triangle.svg": 1209,
	"./amex.png": 1210,
	"./axis-logo.png": 1211,
	"./axisloader.gif": 1212,
	"./axisloader_grey.gif": 1213,
	"./barIcon.svg": 1214,
	"./billDesk.png": 1215,
	"./blackinfo.png": 118,
	"./calender.png": 422,
	"./ccavenue.png": 1216,
	"./check.png": 1217,
	"./checkGreen.png": 132,
	"./close.svg": 55,
	"./copiedIcon.png": 1218,
	"./copy-icon.svg": 423,
	"./copy.png": 1219,
	"./cyber.png": 1220,
	"./delete.png": 241,
	"./deleteIcon.svg": 424,
	"./docIcon.svg": 425,
	"./down-arrow.png": 174,
	"./down-arrow.svg": 407,
	"./download.png": 146,
	"./downloadIcon.png": 84,
	"./drag.svg": 1221,
	"./duplicate.svg": 1222,
	"./error.svg": 393,
	"./failure.png": 1223,
	"./fc-logo-01.png": 392,
	"./fc-logo-02.png": 1224,
	"./fc-logo-03.png": 426,
	"./fc-logo-full.png": 1225,
	"./fcloader.gif": 401,
	"./fcloader_grey.gif": 1226,
	"./file-upload.svg": 243,
	"./file.png": 427,
	"./fileIcon.svg": 428,
	"./filter.png": 403,
	"./fiserv.png": 1227,
	"./forgotimg.png": 429,
	"./generating.gif": 150,
	"./gmv.svg": 430,
	"./graphIcon.svg": 1228,
	"./grayinfo.png": 306,
	"./green-tick-icon.png": 431,
	"./grey-tick-icon.png": 616,
	"./happyFace.svg": 432,
	"./hdfc.png": 1229,
	"./hide.png": 68,
	"./info.svg": 244,
	"./left-arrow.png": 70,
	"./loginimg.png": 433,
	"./mastercard.png": 1230,
	"./migs.png": 1231,
	"./noDataFound.png": 112,
	"./onboarding.png": 1232,
	"./orangeinfo.png": 245,
	"./otp-img.png": 434,
	"./paymentInfo.png": 435,
	"./payu.png": 1233,
	"./payuPg.png": 1234,
	"./picture.png": 246,
	"./profile.png": 199,
	"./refund.png": 1235,
	"./remove.png": 64,
	"./resetimg.png": 436,
	"./retryMerchantIcon.png": 1236,
	"./retryingMerchantIcon.png": 1237,
	"./rupay.png": 1238,
	"./search.svg": 437,
	"./share.png": 1239,
	"./sidebarIcon/accessManagement.png": 395,
	"./sidebarIcon/dashBoard.png": 396,
	"./sidebarIcon/manageAccount.png": 397,
	"./sidebarIcon/manageBin.png": 398,
	"./sidebarIcon/myAccount.png": 399,
	"./sidebarIcon/onboardingImg.png": 394,
	"./sidebarIcon/profile.png": 1240,
	"./sidebarIcon/refundImg.png": 249,
	"./skeletons/bar.gif": 307,
	"./skeletons/line-big.gif": 308,
	"./skeletons/line.gif": 309,
	"./skeletons/pie.gif": 1241,
	"./test1.png": 617,
	"./test2.png": 618,
	"./tick.png": 438,
	"./transactionview.png": 209,
	"./tranx.svg": 439,
	"./tranxCount.svg": 440,
	"./unexpected-error.png": 441,
	"./up-arrow.svg": 406,
	"./upload.svg": 442,
	"./uploadIcon.svg": 443,
	"./view.svg": 198,
	"./visa.png": 1242,
	"./wallet.png": 400,
	"./warning-icon.png": 310,
	"./warning.png": 1243,
	"./wibmo.png": 1244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1201;